<button class="backButton" (click)="goBack()">
  <svg class="navigation__icon navigation__icon--white">
    <use xlink:href="images/sprites.svg#icon-circle-left"></use>
  </svg>
</button>
